import axios from "axios";

// Libs
import {getTokenFromLocalStorage} from "../auth/auth";
import utilsLib from "../common/libs/utils-lib";

// Constants
export const FETCH_STOCKS_REQUEST = "FETCH_STOCKS_REQUEST";
export const FETCH_STOCKS_SUCCESS = "FETCH_STOCKS_SUCCESS";
export const FETCH_STOCKS_ERROR = "FETCH_STOCKS_ERROR";
export const CLEAN_STOCKS_STATE = "CLEAN_STOCKS_STATE";

export const readStocks = (filters = {}) => {
    return async (dispatch) => {
        try {
            dispatch(fetchStocksRequest());

            const token = getTokenFromLocalStorage();

            const res = await axios.post('/api/stocks', {filters}, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, fetchStocksSuccess, fetchStocksError));
        } catch (err) {
            dispatch(utilsLib.response(err, fetchStocksError));
        }
    };
};

const fetchStocksRequest = () => {
    return {
        type: FETCH_STOCKS_REQUEST
    };
};

const fetchStocksSuccess = (payload) => {
    return {
        type: FETCH_STOCKS_SUCCESS,
        payload
    };
};

const fetchStocksError = (errorMessage) => {
    return {
        type: FETCH_STOCKS_ERROR,
        errorMessage
    };
};

export const cleanStocksState = () => {
    return {
        type: CLEAN_STOCKS_STATE
    }
}